import React, { Fragment, useState, useEffect } from 'react';
import SingleSelect from '../../common/Forms/SingleSelect';

const JobTypeSelection = ({ initialJobType, options }) => {
  const [jobType, setJobType] = useState(initialJobType);

  useEffect(() => {
    $("#manual").hide();
    $("#auto").hide();
    $("#interval").hide();

    if (!initialJobType) return;

    if (initialJobType.value === 'auto') {
      $("#manual").hide();
      $("#auto").show();
      $("#interval").hide();
    } else if (initialJobType.value === 'interval') {
      $("#manual").hide();
      $("#auto").hide();
      $("#interval").show();
      } else {
      $("#manual").show();
      $("#auto").hide();
      $("#interval").hide();
    }
  }, [initialJobType])

  const handleChange = (option) => {
    setJobType(option);

    if (option.value === 'auto') {
      $("#manual").hide();
      $("#auto").show();
      $("#interval").hide();
    } else if (option.value === 'interval') {
      $("#manual").hide();
      $("#auto").hide();
      $("#interval").show();
    } else {
      $("#interval").hide();
      $("#manual").show();
      $("#auto").hide();
    }
  };

  return (
    <Fragment>
      <div style={ { width: '100%' } }>
        <input name="scheduled_job[job_type]"
               value={jobType && jobType.value}
               hidden />
        <SingleSelect
          handleChange={handleChange}
          options={options}
          selectedValue={jobType}
          placeholderText="Select job type"
        />
      </div>
    </Fragment>
  )
}

export default JobTypeSelection;
